import {getCurrentInstance, ref} from 'vue';
import useVuelidate from '@vuelidate/core';
import {helpers, minLength, required} from '@vuelidate/validators';
import axiosClient from '../modules/axiosClient';

export default function() {
    const instance = getCurrentInstance();
    const modal = instance?.appContext.config.globalProperties.$modal;
    const showPassword = ref(false);
    const newPassword = ref('');

    const rules = {
        newPassword: {
            required: helpers.withMessage('Please enter your new password', required),
            minLengthValue: minLength(8),
        },
    };

    const v = useVuelidate(rules, {newPassword}, {$scope: false});

    async function setPassword(e: Event) {
        const validationPassed = await v.value.$validate();
        if (validationPassed) {
            const setPasswordUrl = '/api/account/users';
            const postOptions = {password: newPassword.value};
            axiosClient.patch(setPasswordUrl, postOptions).then((response) => {
                if (response.status === 204) {
                    modal?.hide('modal-set-password');
                }
            }, (response) => {
                console.log(response);
            });
        }
    }

    return {
        showPassword,
        newPassword,
        passwordModalValidator: v,
        setPassword,
    };
}
